import * as React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import type { FooterProps } from "../types/navigation";

const linkSx = {
  fontSize: 12.5,
  fontWeight: 700,
  color: "rgba(226,232,240,0.6)",
  textDecoration: "none",
  borderRadius: 1,
  transition: "color 0.2s",
  "&:hover": { color: "#E9D5FF" },
  "&:focus-visible": { outline: "2px solid #A78BFA", outlineOffset: 3 },
};

export default function Footer({ handlePageChange }: FooterProps) {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        px: { xs: 2, md: 4 },
        py: { xs: 2, sm: 1.75 },
        bgcolor: "#08050b",
        backgroundImage:
          "linear-gradient(90deg, rgba(9,5,11,0) 0%, rgba(88,29,127,0.16) 50%, rgba(9,5,11,0) 100%)",
        borderTop: "1px solid rgba(168,85,247,0.2)",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems="center"
        justifyContent="space-between"
        spacing={{ xs: 1.25, sm: 2 }}
        sx={{ width: "100%", maxWidth: 1180, mx: "auto" }}
      >
        {/* BRAND / RIGHTS */}
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0 }}>
          <Box
            component="img"
            src="/logo.png"
            alt=""
            sx={{
              width: 26,
              height: 26,
              flexShrink: 0,
              objectFit: "contain",
              borderRadius: 1.5,
              bgcolor: "rgba(255,255,255,0.92)",
              p: 0.4,
            }}
          />
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 1.4,
              color: "rgba(226,232,240,0.6)",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            Stellaris Space Adventures © 2025 · All rights reserved
          </Typography>
        </Stack>

        {/* LINKS */}
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center" flexWrap="wrap" useFlexGap rowGap={0.5}>
          <Link component="button" type="button" onClick={() => handlePageChange("Terms")} sx={linkSx}>
            Terms & Conditions
          </Link>

          <Box sx={{ width: 3, height: 3, borderRadius: "50%", bgcolor: "rgba(168,85,247,0.6)" }} />

          <Link component="button" type="button" onClick={() => handlePageChange("Privacy")} sx={linkSx}>
            Privacy Policy
          </Link>

          <Box sx={{ width: 3, height: 3, borderRadius: "50%", bgcolor: "rgba(168,85,247,0.6)" }} />

          <Link component="button" type="button" onClick={() => handlePageChange("LegalNotice")} sx={linkSx}>
            Legal Notice
          </Link>
        </Stack>
      </Stack>
    </Box>
  );
}
